import { render, staticRenderFns } from "./InvoiceQ.vue?vue&type=template&id=62b9dc0f&scoped=true"
import script from "./InvoiceQ.vue?vue&type=script&lang=js"
export * from "./InvoiceQ.vue?vue&type=script&lang=js"
import style0 from "./InvoiceQ.vue?vue&type=style&index=0&id=62b9dc0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9dc0f",
  null
  
)

export default component.exports